const DOCUMENT_MANAGER_BASE_URL = "https://documentmanager.sababisha.com";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token")?.replace(/"/g, "");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${DOCUMENT_MANAGER_BASE_URL}${normalizedPath}`;
};

const readErrorMessage = async (response) => {
  try {
    const body = await response.json();
    return body?.detail || body?.message || `Request failed with status ${response.status}`;
  } catch {
    return `Request failed with status ${response.status}`;
  }
};

export const listDocuments = async (path) => {
  const response = await fetch(buildUrl(path), {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  const data = await response.json();

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.documents)) return data.documents;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const downloadDocumentBlob = async (documentType, documentId) => {
  const response = await fetch(
    buildUrl(`/documents/${documentType}/${documentId}/download`),
    {
      method: "GET",
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return {
    blob: await response.blob(),
    contentType: response.headers.get("content-type") || "",
  };
};

export const uploadDocuments = async (path, fields, files) => {
  const formData = new FormData();

  Object.entries(fields || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const uploadFiles = Array.isArray(files) ? files : [files].filter(Boolean);
  uploadFiles.forEach((file) => {
    formData.append("files", file);
  });

  const response = await fetch(buildUrl(path), {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return response.json();
};

export const triggerBlobDownload = (blob, fileName) => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName || "document";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
